export default function CostAvoidanceDataTable() {
  return (
    <h1>Hi from the Data Table</h1>
  )
}